import { colord } from 'colord'
import RCPagination from 'rc-pagination'
import styled from 'styled-components'

export const StyledPagination = styled(RCPagination)`
  display: flex;
  width: fit-content;

  & > li:not(.rc-pagination-options) {
    font-family: 'Quicksand', 'Sarabun', sans-serif;
    font-size: 16px;
    font-weight: 500;
    height: 40px;
    border: 1px solid #dddddd;
    border-radius: 0;
    margin-right: 0;
    padding: 0 16px;
    display: flex;
    align-items: center;
    justify-content: center;

    & > a {
      padding: 0;
    }

    &:not(.rc-pagination-prev) {
      border-left: none;
    }

    &.rc-pagination-prev {
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
    }

    &.rc-pagination-next {
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
    }

    &.rc-pagination-disabled {
      color: #7b7b7b;
      cursor: initial;
    }

    &.rc-pagination-item-active {
      color: white;
      background-color: ${({ theme }) => theme.colors.primary};

      & > a {
        color: white;
      }
    }

    &:hover {
      border-color: #dddddd;
    }

    &:not(.rc-pagination-disabled):not(.rc-pagination-item-active):hover {
      background-color: ${({ theme }) =>
        colord(theme.colors.primary).alpha(0.2).toHex()};

      & > a {
        color: black;
      }
    }
  }
`
